import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px 50px 100px 50px;
`;

export const Heading = styled.div`
  padding: 50px 0px 20px 0px;
  text-align: start;
`;
